module.exports = __webpack_public_path__ + "static/desktop/img/life-4.9b1da08c.jpg";